<template>
  <b-form-group :label="title">
    <b-form-tags v-model="selectedTag" no-outer-focus class="mb-2">
      <template v-slot="{ tags, addTag, removeTag }">
        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
          <li v-for="tag in tags" :key="tag" class="list-inline-item">
            <b-form-tag :title="tag" variant="info" @remove="removeTag(tag)">
              {{ tag }}
            </b-form-tag>
          </li>
        </ul>

        <b-dropdown size="sm" variant="primary" block menu-class="w-100">
          <template v-slot:button-content variant="danger">{{
            placeholder
          }}</template>
          <b-dropdown-form @submit.stop.prevent="() => {}">
            <b-form-group
              :label-for="tagInputId"
              :label="$t('form.research')"
              label-cols-md="auto"
              class="mb-0"
              label-size="sm"
            >
              <b-form-input
                :id="tagInputId"
                v-model="search"
                type="search"
                size="sm"
                autocomplete="off"
              />
            </b-form-group>
          </b-dropdown-form>
          <b-dropdown-divider />
          <b-dropdown-item-button
            v-for="option in availableOptions"
            :key="option[propertyText]"
            @click="onOptionClick({ option, addTag })"
          >
            {{ option[propertyText] }}
          </b-dropdown-item-button>
          <b-dropdown-text v-if="availableOptions.length === 0">{{
            searchNoResultMessage
          }}</b-dropdown-text>
        </b-dropdown>
      </template>
    </b-form-tags>
  </b-form-group>
</template>

<script>
import { uniq, compact } from "lodash";

export default {
  name: "BTagSelect",
  props: {
    value: {
      // selectedOptions
      type: Array,
      default() {
        return [];
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "",
    },
    searchNoResultMessage: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    suggestionLimite: {
      type: Number,
      default: 5,
    },
    propertyText: {
      type: String,
      default: "",
    },
    propertyValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      search: "",
      tagInputId: this.generateUniqueTagId(),
    };
  },
  computed: {
    criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      // Filter out already selected options
      const options = this.options.filter(
        (option) => !this.value.includes(option[this.propertyValue])
      );
      if (criteria) {
        // Show only options that match criteria
        return options.filter(
          (opt) =>
            opt[this.propertyText] !== undefined &&
            opt[this.propertyText].toLowerCase().indexOf(criteria) > -1
        );
      }
      // Show all options available
      return options.slice(0, this.suggestionLimite);
    },
    selectedTag: {
      get() {
        /*
          return an array of tag 
          according to the selected options
         */

        const label = this.propertyText;

        const result = this.value.map((el) => {
          const correspondingOption = this.options.find(
            (option) => option[this.propertyValue] === el
          );

          return correspondingOption ? correspondingOption[label] : "";
        });

        // remove duplicate and empty string from the array
        return compact(uniq(result));
      },
      set(val) {
        const correspondingOptions = this.options
          .filter((option) => val.includes(option[this.propertyText]))
          .map((option) => option[this.propertyValue]);

        this.$emit("input", correspondingOptions);
      },
    },
  },

  methods: {
    onOptionClick({ option, addTag }) {
      addTag(option[this.propertyText]);
      this.search = "";
    },
    generateUniqueTagId() {
      let result = "",
        t;
      let num = Math.ceil(Math.random() * 100000000);

      while (num > 0) {
        t = (num - 1) % 26;
        result = String.fromCharCode(65 + t) + result;
        num = ((num - t) / 26) | 0;
      }

      return result;
    },
  },
};
</script>
